<template>
	<nav class="pcoded-navbar">
        <div class="pcoded-inner-navbar">
            <ul class="pcoded-item pcoded-left-item">
                <li>
                    <a href="/stage1" v-if="user.present_stage > 1">
                        <span class="pcoded-micon completed" title="Completed">
                            <i class="ti-check"></i>
                        </span>
                        <span class="pcoded-mtext">Stage 1</span>
                    </a>
                </li>
                <li class="p-l-20 p-r-20">
                    <span>
                        <i class="ti-arrow-right"></i>
                    </span>
                </li>
                <li>
                    <a href="/stage2" v-if="user.present_stage > 2">
                        <span class="pcoded-micon completed" title="Completed">
                            <i class="ti-check"></i>
                        </span>
                        <span class="pcoded-mtext">Stage 2</span>
                    </a>
                    <a v-else-if="user.present_stage == 2" href="/stage2">
                        <span class="pcoded-micon pending" title="In Progress">
                            <i class="ti-timer"></i>
                        </span>
                        <span class="pcoded-mtext">
                            <b>Stage 2</b>
                        </span>
                    </a>
                </li>
                <li class="p-l-20 p-r-20" v-if="user.present_stage > 2">
                    <span>
                        <i class="ti-arrow-right"></i>
                    </span>
                </li>
                <li>
                    <a href="/stage3" v-if="user.present_stage > 3">
                        <span class="pcoded-micon completed" title="Completed">
                            <i class="ti-check"></i>
                        </span>
                        <span class="pcoded-mtext">Stage 3</span>
                    </a>
                    <a v-else-if="user.present_stage == 3" href="/stage3">
                        <span class="pcoded-micon pending" title="In Progress">
                            <i class="ti-timer"></i>
                        </span>
                        <span class="pcoded-mtext">
                            <b>Stage 3</b>
                        </span>
                    </a>
                </li>
            </ul>
        </div>
    </nav>
</template>
<style scoped>
    .pcoded-left-item{
        text-align: center;
        float: none !important;
    }
    .pcoded .pcoded-navbar .pcoded-item > li{
        float: none;
        display: inline-block;
    }
    li a{
        line-height: 2.3 !important;
    }
    .disabled{
        cursor: not-allowed !important;
        pointer-events: none;
    }
    .completed{
        background-color: #3bd33b !important;
    }
    .pending{
        background-color: #fda01c !important;
    }
    .pcoded[nav-type="st1"] .pcoded-item.pcoded-left-item > li > a > .pcoded-micon i, .pcoded[nav-type="st3"] .pcoded-item.pcoded-left-item > li > a > .pcoded-micon i{
        display: inline-block !important;
    }
    .p-l-20{
        padding-left: 20px !important;
    } 
    .p-r-20{
        padding-right: 20px !important;
    }

</style>
<script>
    import '@/assets/js/jquery.min.js'

	export default{
		name: 'Menu',
        data(){
            return{
                role: '',
                selected: localStorage.getItem('selected'),
                user: {}
            }
        },
        mounted(){
            this.user = this.$store.getters.user_data.data
        },
        methods:{
            select(what){
                localStorage.setItem('selected', what)
            }
        }
	}
</script>